module.exports = __webpack_public_path__ + "img/basicIndex.646ee7cf.png";